import { compose } from 'redux';
import { WithFetchDatasFromCMS, WithFetchDatasFromCMSInputProps, WithCMSSEO } from 'modules/shared-cms/hocs';

import { HomeAltProps } from '.';
import { QUERY } from './home-alt-query';
import { HomeAltLoader } from './home-alt-loader';

const enhancer = compose<React.ComponentType<WithFetchDatasFromCMSInputProps>>(
    WithFetchDatasFromCMS<HomeAltProps>(QUERY, HomeAltLoader, 'queryHomeV2Contents'),
    WithCMSSEO(undefined, true),
);
export default enhancer;
